import React from 'react';
import { Toolbar } from 'react-md';

import './Header.css'
import Logo from 'img/logo.svg'

export default () => (
	<div className="header">
		<Toolbar
			className="header-toolbar-main"
			title={<img src={Logo} className="header-logo" alt="SENSOTIX" />}
		/>
		<Toolbar
			className="header-toolbar-sub"
			title="Showroom Dashboard"
		/>
	</div>
);



// WEBPACK FOOTER //
// ./src/components/header/Header.jsx